export default function BrandStory() {
  const stats = [
    { value: "500+", label: "Happy Customers" },
    { value: "30+", label: "Premium Products" },
    { value: "5yr", label: "Warranty Coverage" },
    { value: "4.7★", label: "Average Rating" },
  ];

  return (
    <section className="py-24 bg-[#F9F7F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="w-full h-[520px] rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/d0cb72a55d99794adec453c0183cfaa3.jpg"
                alt="ARAVELLA craftsmanship"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 shadow-lg max-w-[200px]">
              <div className="text-3xl font-bold text-[#2D5016] mb-1">Grade A</div>
              <div className="text-gray-500 text-sm">Teak Wood Only</div>
              <div className="mt-3 flex items-center gap-1">
                {[1,2,3,4,5].map(s => (
                  <i key={s} className="ri-star-fill text-amber-400 text-xs"></i>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <span className="text-[#4A7C2F] text-sm font-medium tracking-widest uppercase">Our Story</span>
            <h2 className="text-4xl font-bold text-[#1a1a1a] mt-3 mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Built for the<br />Arizona Outdoor Life
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Founded in Phoenix, ARAVELLA LLC was born from a passion for outdoor living. We believe your patio, deck, or garden deserves the same care and quality as your interior spaces.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-10">
              Every piece in our collection is carefully selected for durability, beauty, and comfort — crafted to withstand Arizona&apos;s intense sun while looking stunning year after year.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map(stat => (
                <div key={stat.label} className="bg-white rounded-xl p-5">
                  <div className="text-3xl font-bold text-[#2D5016] mb-1">{stat.value}</div>
                  <div className="text-gray-400 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
